export default function timeToPercentage(seconds, duration) {
  if (!seconds || !duration) {
    return 0;
  }
  const parsedSeconds = parseFloat(seconds);
  const parsedDuration = parseFloat(duration);
  if (!parsedSeconds || !parsedDuration) {
    return 0;
  }
  return (parsedSeconds / parsedDuration) * 100;
}
